function ClipboardIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83333 12.3678H9.66667V14.0345H3.83333V12.3678ZM3.83333 9.0345H12.1667V10.7012H3.83333V9.0345ZM3.83333 5.70117H12.1667V7.36784H3.83333V5.70117ZM13.8333 2.36784H10.35C10 1.40117 9.08333 0.701172 8 0.701172C6.91667 0.701172 6 1.40117 5.65 2.36784H2.16667C2.05 2.36784 1.94167 2.37617 1.83333 2.40117C1.50833 2.46784 1.21667 2.63451 0.991667 2.85951C0.841667 3.00951 0.716667 3.19284 0.633333 3.39284C0.55 3.58451 0.5 3.80117 0.5 4.03451V15.7012C0.5 15.9262 0.55 16.1512 0.633333 16.3512C0.716667 16.5512 0.841667 16.7262 0.991667 16.8845C1.21667 17.1095 1.50833 17.2762 1.83333 17.3428C1.94167 17.3595 2.05 17.3678 2.16667 17.3678H13.8333C14.75 17.3678 15.5 16.6178 15.5 15.7012V4.03451C15.5 3.11784 14.75 2.36784 13.8333 2.36784ZM8 2.15951C8.34167 2.15951 8.625 2.44284 8.625 2.78451C8.625 3.12617 8.34167 3.40951 8 3.40951C7.65833 3.40951 7.375 3.12617 7.375 2.78451C7.375 2.44284 7.65833 2.15951 8 2.15951ZM13.8333 15.7012H2.16667V4.03451H13.8333V15.7012Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ClipboardIcon;
